const { NODE_ENV } = process.env;
const dev = NODE_ENV === 'development';

//urls
export const URLS = {
  ONETREE_API_URL: dev
    ? process.env.ONETREE_API_STAGING_URL
    : process.env.ONETREE_API_PROD_URL,
  ONEWORLD_API_URL: dev
    ? process.env.ONEWORLD_API_STAGING_ENDPOINT
    : process.env.ONEWORLD_API_PROD_ENDPOINT
};

//keys
export const KEYS = {
  LOUNGES_APP_KEY: dev
    ? process.env.LOUNGES_STAGING_APP_KEY
    : process.env.LOUNGES_PROD_APP_KEY,
  AIRPORT_APP_KEY: dev
    ? process.env.AIRPORT_STAGING_APP_KEY
    : process.env.AIRPORT_PROD_APP_KEY,
  ONEWORLD_APP_KEY: dev
    ? process.env.ONEWORLD_STAGING_APP_KEY
    : process.env.ONEWORLD_PROD_APP_KEY
};

export const IDS = {
  AIRPORT_APP_ID: process.env.AIRPORT_APP_ID,
  LOUNGES_APP_ID: process.env.LOUNGES_APP_ID,
  ONEWORLD_APP_ID: process.env.ONEWORLD_APP_ID
};

// endpoints
export const ENDPOINTS = {
  // GET
  getAirports: `${URLS.ONETREE_API_URL}/wayfinding/v1/Airports`,
  findLounges: `${URLS.ONETREE_API_URL}/lounge/v1/lounges/airport`,
  searchFlights: `${URLS.ONEWORLD_API_URL}/onetree-api/api/v1/flight-search`,
  getAirlines: `${URLS.ONEWORLD_API_URL}/onetree-api/api/v1/airlines`,
  deepLink: `${URLS.ONEWORLD_API_URL}/onetree-api/api/v1/deep-link`
};

export const TIERSMAP = {
  SapphireAndHigher: ['Sapphire', 'Emerald'],
  RubyAndHigher: ['Ruby', 'Sapphire', 'Emerald'],
  Emerald: ['Emerald'],
  Sapphire: ['Sapphire'],
  Ruby: ['Ruby']
};

export const ACCESS_CLASS_MAP = {
  BusinessAndHigher: ['Business', 'First'],
  First: ['First']
};

export const AMENITIES_ARRAY = [
  'BusinessCenter',
  'TV',
  'FoodBeverageSnackBuffet',
  'Phone',
  'PreFlightDinner',
  'RelaxationRoom',
  'Shower',
  'SPA',
  'WheelchairAccess',
  'WiFi'
];

export const FACILITIES_ARRAY = [
  'BusinessCenter',
  'FoodBeverageHotBuffet',
  'WheelchairAccess',
  'Shower',
  'AirConditioning',
  'Restroom',
  'RunwayViews',
  'FlighInformationScreen'
];

export const FOOD_BEVERAGE_ARRAY = [
  'FoodBeverageSnackBuffet',
  'FoodBeveragesAlcoholic',
  'FoodBeverageChampagne',
  'FoodBeverageHotBuffet',
  'FoodBeverageHotFood',
  'FoodBeverageAlaCarte',
  'FoodBeverageVegetarian',
  'FoodBeverageWaiter',
  'PreFlightDinner',
  'FoodBeverageSpecialCoffee'
];

export const ENTERTAINMENT_COMMS_ARRAY = [
  'TV',
  'EthernetConnection',
  'ChargingFacticilites',
  'Phone',
  'ReadingMaterials'
];

export const AIRLINE_LOGOS = {
  KA: '/images/airlines/cathay-dragon/cathay-dragon-logo.png',
  '4M': '/images/airlines/latam/latam-logo.png',
  XL: '/images/airlines/latam/latam-logo.png'
};

export const DATE_FORMAT = 'm/d/Y';
export const FLIGHT_DATE_FORMAT = 'd/M/Y';

// breakpoints
export const BREAKPOINT = {
  mobile: 320,
  tablet: 768,
  desktop: 1025,
  wide: 1440
};
